export default __webpack_public_path__ + "static/media/plain-sticker-i.33c92711.png";